var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3,137.2c0.1-14.6,2.2-26.5,6.8-37.4c7.4-17.7,17.4-29.9,29.8-36.1c2.9-1.5,5.5-1.5,8.4,0c11.1,5.6,20.7,16.6,28.4,32.8 c5.3,11.1,8,23.1,8,35.5c0,15.8-1.5,43-2.1,52.2h15.8c0.9-29,1.7-62.3,1.7-78.1c0-17.3-3.6-34.3-11.4-50.5 c-8-16.7-20.8-30.5-40.2-40.2c-3.1-1.6-5.5-1.5-8.6,0.1c-21.5,10.6-34.5,26.2-42.3,44.8c-7.3,17.4-9.6,35.4-9.7,53.6 c-0.1,10.1,0.9,41.4,1.9,70.3h15.8C89,174.7,87.2,147.1,87.3,137.2L87.3,137.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90,190.1H74c0.6,18.4,1.2,35,1.6,43.5c0.1,1.6,0.2,3.1,0.6,4.6c0.7,2.3,2.6,3.6,5.8,3.5c4.7-0.1,9.3-0.1,14-0.1 c2.6,0,4.2-0.8,5.1-2.7c1.4-3,2.8-6,4.1-9.1c0.7-1.6,1.8-2.3,4.1-2.3c12.7,0.1,25.4,0.1,38.1,0c2,0,3.2,0.4,3.9,2.1 c1.1,2.9,2.5,5.7,3.8,8.6c1.1,2.3,2.9,3.6,6.3,3.4c4.4-0.1,8.9,0,13.3,0c3.6,0,5.3-1.2,5.9-4c0.2-1.1,0.2-2.2,0.3-3.3 c0.2-5.8,0.8-23.5,1.4-44.2L90,190.1L90,190.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.7,131.9c0-11.5-2.5-22.6-7.4-32.9c-7.1-14.9-15.7-25-25.6-30c-1.2-0.6-1.8-0.6-3.1,0c-11.1,5.5-20.2,16.6-27,33 c-4.2,10.2-6.2,21.3-6.3,35.1c-0.1,9.7,1.7,37.9,2.3,46.9h65C161.1,175.3,162.7,147.8,162.7,131.9L162.7,131.9z M128,146.9 c-10.4,0-18.9-8.5-18.9-18.9s8.5-18.9,18.9-18.9s18.9,8.5,18.9,18.9S138.4,146.9,128,146.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.1,119.1c-2.1-1.6-4.6-2.4-7.1-2.4c-3.4,0-6.9,1.4-9.2,4.5c-3.1,4.1-3.1,9.9,0,13.9c2.3,3,5.8,4.5,9.2,4.5 c2.5,0,5.1-0.7,7.1-2.4C141,132.6,141,123.7,135.1,119.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8e384f2f3352c319e023982b298eb63f.svg";
export { ForwardRef as ReactComponent };